import { render, staticRenderFns } from "./UniversesModal.vue?vue&type=template&id=1644532f&scoped=true"
import script from "./UniversesModal.vue?vue&type=script&lang=js"
export * from "./UniversesModal.vue?vue&type=script&lang=js"
import style0 from "./UniversesModal.vue?vue&type=style&index=0&id=1644532f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1644532f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/_work/studio-admin/studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1644532f')) {
      api.createRecord('1644532f', component.options)
    } else {
      api.reload('1644532f', component.options)
    }
    module.hot.accept("./UniversesModal.vue?vue&type=template&id=1644532f&scoped=true", function () {
      api.rerender('1644532f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UniversesModal.vue"
export default component.exports